import { useQuery } from "react-query";
import { getAdminCatalog } from "services/verificationService.service";

export default function useVerificationServices() {
  return useQuery(["verification-services-catalog"], getAdminCatalog);
}
